// extracted by mini-css-extract-plugin
module.exports = {"container-spinner":"styles_container-spinner__9QTOR"};